import trainer1 from "../images/trainer1.jpg";
import trainer2 from "../images/trainer2.jpg";
import trainer3 from "../images/trainer3.jpg";

export const testimonialData = [
  {
    image: trainer1,
    review:
      "I have made the right choice by joining JD gym. It has been the best decision as I am already seeing results.",
    name: "Sarah Cook",
    prof: "Customer",
  },
  {
    image: trainer2,
    review:
      "We have the best equipment and our trainer are higly qualified and eager to help anyone trying to achieve their fitness goals.",
    name: "Micehal Bisping",
    prof: "Trainer",
  },
  {
    image: trainer3,
    review:
      "We make sure our space is clean and tidy so that the customers have the best experience possible.",
    name: "Tyrone Johnson",
    prof: "Coach",
  },
];
